import { DimensionWindow } from "components/window/core/dimension";
import { ObjectTreeWindow } from "components/window/core/objectTree";
import { PropertiesWindow } from "components/window/core/properties/propertiesWindow";
import { SettingsWindow } from "components/window/core/settings/settingsWindow";
import { CORE_WINDOW_IDS } from "contexts/windows/constants";

// This initial value does nothing other than satisfy the type.
// The actual zIndex value is handled dynamically in the reducer.
const zIndex = 1000;

export const DEFAULT_WINDOW_STATE = {
    [CORE_WINDOW_IDS.PROPERTIES]: {
        config: {
            id: CORE_WINDOW_IDS.PROPERTIES,
            defaultPosition: "center",
            component: PropertiesWindow,
        },
        state: {
            open: false,
            position: "center" as const,
            zIndex,
        },
    },
    [CORE_WINDOW_IDS.SETTINGS]: {
        config: {
            id: CORE_WINDOW_IDS.SETTINGS,
            defaultPosition: {
                elementId: "quick-access-camera",
                placement: "left",
                align: { vertical: "top" },
            },
            component: SettingsWindow,
        },
        state: {
            open: false,
            position: {
                elementId: "quick-access-camera",
                placement: "left",
                align: { vertical: "top" },
            } as const,
            zIndex,
        },
    },
    [CORE_WINDOW_IDS.OBJECT_TREE]: {
        config: {
            id: CORE_WINDOW_IDS.OBJECT_TREE,
            defaultPosition: "center",
            component: ObjectTreeWindow,
        },
        state: {
            open: false,
            position: "center" as const,
            zIndex,
        },
    },
    [CORE_WINDOW_IDS.DIMENSION]: {
        config: {
            id: CORE_WINDOW_IDS.DIMENSION,
            defaultPosition: "center",
            component: DimensionWindow,
        },
        state: {
            open: false,
            position: "center" as const,
            zIndex,
        },
    },
} as const;
